import { Item } from "../types/common.types";

export interface SidebarCheckList extends ItemCheck {
  id: number | string;
  key: string;
  countActiveFilters: number;
  filters: Map<string, number[]>;
  sublist?: SidebarCheckList[];
}

export type SidebarMenu = {
  id: number | string;
  sublist?: SidebarMenu[];
} & ItemCheck & { key: string };

export interface Sidebar {
  categories?: ItemCheck[];
  subcategories: ItemCheck[];
  subcategoriesSons?: ItemCheck[];
  producers?: ItemCheck[];
  tags?: ItemCheck[];
  dietRestrictions?: ItemCheck[];
  tagsCategories: {
    id: number;
    name: string;
    tags: ItemCheck[]
  }[]
}

export interface ItemCheck extends Item {
  checked?: boolean
  disabled?: boolean
}

export enum SidebarFilterTypes {
  producers = 'producers',
  dietRestrictions = 'dietrestrictions',
  tags = 'tags'
};

export type FilterTag = {
  name: string;
  listId: number | string;
  sublistId: number | string;
}
